/* NovaNox Produktseite v2 (nnp) – gehört zu sections/nn-pdp.liquid. Keine Abhängigkeiten. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.__nnp) return;
    var dataEl = root.querySelector('[data-nnp-json]');
    if (!dataEl) return;
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.__nnp = true;
    root.classList.add('is-js');

    var $ = function (s, c) { return (c || root).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
    var form = document.getElementById(root.getAttribute('data-form-id'));
    var variants = D.variants || [];
    var tiers = (D.tiers || []).filter(function (t) { return t.qty > 0 && t.pct > 0; }).sort(function (a, b) { return a.qty - b.qty; });
    var state = { variant: null, qty: 1, cartQty: 0, cartTotal: 0, cartCount: 0, shownTotal: null };

    /* ---------- Helfer ---------- */
    /* Gleiche Schreibweise wie Liquid-money auf dieser Seite („13,99 €") */
    var moneyFmt;
    try { moneyFmt = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: D.currency || 'EUR' }); } catch (e) { moneyFmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }); }
    function money(cents) { return moneyFmt.format(cents / 100); }
    function pctPrice(price, pct) { return Math.round(price * (100 - pct) / 100); }
    function bump(el) {
      if (!el || reduceMotion) return;
      el.classList.remove('nnp-bump'); void el.offsetWidth; el.classList.add('nnp-bump');
    }
    var toastTimer;
    function toast(msg) {
      var t = $('[data-nnp-toast]');
      if (!t) return;
      t.textContent = msg;
      t.classList.add('is-show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { t.classList.remove('is-show'); }, 2600);
    }
    function scrollToEl(el, block) {
      if (!el) return;
      var top = el.getBoundingClientRect().top + window.pageYOffset - (block === 'center' ? window.innerHeight / 3 : 90);
      window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function tween(el, from, to) {
      if (!el) return;
      if (reduceMotion || from === null || from === to) { el.textContent = money(to); return; }
      var start = null, dur = 380;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = money(Math.round(from + (to - from) * e));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    /* ---------- Varianten ---------- */
    var optionSets = $$('[data-nnp-option]');
    function selectedOptions() {
      return optionSets.map(function (fs) {
        var sel = fs.querySelector('[data-nnp-option-select]');
        if (sel) return sel.value;
        var r = fs.querySelector('input[data-nnp-option-input]:checked');
        return r ? r.value : null;
      });
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function resolve(opts, changed) {
      var v = findVariant(opts);
      if (v) return v;
      var best = null, bestScore = -1;
      variants.forEach(function (x) {
        if (changed != null && x.options[changed] !== opts[changed]) return;
        var s = x.available ? 100 : 0;
        x.options.forEach(function (o, i) { if (o === opts[i]) s++; });
        if (s > bestScore) { bestScore = s; best = x; }
      });
      return best;
    }
    function syncOptionInputs(v) {
      optionSets.forEach(function (fs, i) {
        var val = v.options[i];
        var sel = fs.querySelector('[data-nnp-option-select]');
        if (sel) sel.value = val;
        fs.querySelectorAll('input[data-nnp-option-input]').forEach(function (inp) { inp.checked = inp.value === val; });
        var lbl = fs.querySelector('[data-nnp-option-value]');
        if (lbl) lbl.textContent = val;
        var ddv = fs.querySelector('[data-nnp-dd-value]');
        if (ddv) ddv.textContent = val;
        var ddm = fs.querySelector('[data-nnp-dd-meta]');
        if (ddm) ddm.textContent = v.available ? '' : 'ausverkauft';
      });
    }
    function markAvailability(v) {
      if (!v) return;
      optionSets.forEach(function (fs, i) {
        var isColor = !!fs.querySelector('.nnp-pills--color');
        var check = function (value) {
          return variants.some(function (x) {
            if (x.options[i] !== value || !x.available) return false;
            if (isColor) return true;
            for (var j = 0; j < x.options.length; j++) { if (j !== i && x.options[j] !== v.options[j]) return false; }
            return true;
          });
        };
        var ddPrices = [];
        fs.querySelectorAll('input[data-nnp-option-input]').forEach(function (inp) {
          var holder = inp.closest('.nnp-pill, .nnp-dd__opt');
          if (holder) holder.classList.toggle('is-unavailable', !check(inp.value));
          var priceEl = holder && holder.querySelector('[data-nnp-dd-price]');
          if (priceEl) {
            var opts = v.options.slice(); opts[i] = inp.value;
            var match = findVariant(opts) || variants.filter(function (x) { return x.options[i] === inp.value; })[0];
            ddPrices.push({ el: priceEl, v: match });
          }
        });
        if (ddPrices.length) {
          var distinct = {};
          ddPrices.forEach(function (p) { if (p.v) distinct[p.v.price] = 1; });
          var showPrice = Object.keys(distinct).length > 1;
          ddPrices.forEach(function (p) {
            p.el.textContent = !p.v ? '' : (!p.v.available ? 'ausverkauft' : (showPrice ? money(p.v.price) : ''));
          });
        }
        var sel = fs.querySelector('[data-nnp-option-select]');
        if (sel) {
          Array.prototype.forEach.call(sel.options, function (o) {
            if (!o.dataset.label) o.dataset.label = o.textContent;
            o.textContent = o.dataset.label + (check(o.value) ? '' : ' – ausverkauft');
          });
        }
      });
    }
    function stockInfo(v) {
      if (!v || !v.available) return { state: 'out', text: 'Ausverkauft' };
      if (v.tracked && v.qty <= 0 && v.policy === 'continue') {
        return D.backorderText ? { state: 'backorder', text: 'Wird für dich gefertigt – Lieferzeit ' + D.backorderText } : { state: 'available', text: D.continueText };
      }
      if (v.tracked && v.qty <= D.lowStock) return { state: 'low', text: 'Nur noch ' + v.qty + ' Stück auf Lager' };
      return { state: 'in', text: D.inStockText };
    }
    function maxQty(v) { return v && v.tracked && v.policy === 'deny' && v.qty > 0 ? v.qty : 9999; }

    function setVariant(v, opts) {
      opts = opts || {};
      if (!v) return;
      var prev = state.variant;
      state.variant = v;
      $$('input[name="id"]').forEach(function (inp) { inp.value = v.id; });
      syncOptionInputs(v);
      markAvailability(v);

      var onSale = v.compare > v.price;
      var priceEl = $('[data-nnp-price]');
      if (priceEl) {
        priceEl.textContent = money(v.price);
        priceEl.classList.toggle('is-sale', onSale);
        if (prev && prev.price !== v.price) bump(priceEl);
      }
      var cmp = $('[data-nnp-compare]');
      if (cmp) { cmp.hidden = !onSale; if (onSale) cmp.textContent = money(v.compare); }
      var badge = $('[data-nnp-sale-badge]');
      if (badge) { badge.hidden = !onSale; if (onSale) badge.textContent = '−' + Math.round((v.compare - v.price) * 100 / v.compare) + ' %'; }
      var unit = $('[data-nnp-unit]');
      if (unit) { unit.hidden = !v.unit; if (v.unit) unit.textContent = v.unit + ' · '; }
      var sku = $('[data-nnp-sku]');
      if (sku) { sku.textContent = v.sku || ''; sku.parentNode.hidden = !v.sku; }
      var best = $('[data-nnp-best-price]');
      if (best && tiers.length) best.textContent = money(pctPrice(v.price, tiers[tiers.length - 1].pct));
      $$('[data-nnp-tier]').forEach(function (b) {
        var el = b.querySelector('[data-nnp-tier-price]');
        if (el) el.textContent = money(pctPrice(v.price, parseFloat(b.getAttribute('data-pct')) || 0));
      });

      var st = stockInfo(v);
      var stock = $('[data-nnp-stock]');
      if (stock) { stock.setAttribute('data-state', st.state); stock.querySelector('[data-nnp-stock-text]').textContent = st.text; }
      renderDelivery(st.state);

      var atc = $('[data-nnp-atc]');
      var label = $('[data-nnp-atc-label]');
      var atcText = (atc && atc.getAttribute('data-label')) || D.atcLabel;
      if (atc) {
        atc.disabled = !v.available;
        if (label) label.textContent = v.available ? atcText : 'Ausverkauft';
      }
      var sAtc = $('[data-nnp-sticky-atc]');
      if (sAtc) { sAtc.disabled = !v.available; $('[data-nnp-sticky-label]').textContent = v.available ? atcText : 'Ausverkauft'; }
      var sVar = $('[data-nnp-sticky-variant]');
      if (sVar && !D.hasOnlyDefault) sVar.textContent = v.title;

      var qEl = $('[data-nnp-qty]');
      var mx = maxQty(v);
      if (qEl) { if (mx < 9999) qEl.max = mx; else qEl.removeAttribute('max'); }
      if (state.qty > mx) { setQty(mx); toast('Maximal ' + mx + ' Stück sofort lieferbar'); }

      if (opts.user) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) {}
        if (v.media) goToMedia(v.media);
      }
      highlightDatasheet();
      xsMatch();
      recalc();
    }

    /* Ausklapp-Menü (viele Größen) */
    $$('[data-nnp-dd]').forEach(function (dd) {
      var btn = dd.querySelector('[data-nnp-dd-btn]');
      var panel = dd.querySelector('[data-nnp-dd-panel]');
      var open = function (state) {
        panel.hidden = !state;
        dd.classList.toggle('is-open', state);
        btn.setAttribute('aria-expanded', state ? 'true' : 'false');
        if (state) {
          var cur = panel.querySelector('input:checked');
          if (cur) { cur.closest('.nnp-dd__opt').scrollIntoView({ block: 'nearest' }); cur.focus({ preventScroll: true }); }
        }
      };
      btn.addEventListener('click', function () { open(panel.hidden); });
      panel.addEventListener('click', function (e) { if (e.target.closest('.nnp-dd__opt')) setTimeout(function () { open(false); btn.focus(); }, 120); });
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Enter') { e.preventDefault(); open(false); btn.focus(); }
      });
      document.addEventListener('click', function (e) { if (!dd.contains(e.target)) open(false); });
    });

    /* Viele Größen: erst N zeigen, Rest per Link (ausgewählte Größe bleibt immer sichtbar) */
    optionSets.forEach(function (fs) {
      var n = parseInt(fs.getAttribute('data-visible'), 10);
      var pills = fs.querySelectorAll('.nnp-pill');
      if (!n || pills.length <= n + 2) return;
      for (var i = n; i < pills.length; i++) pills[i].classList.add('is-overflow');
      fs.classList.add('is-collapsed');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nnp-textlink nnp-more';
      var label = function () { btn.textContent = fs.classList.contains('is-collapsed') ? 'Alle ' + pills.length + ' Größen' : 'Weniger Größen'; };
      label();
      btn.addEventListener('click', function () { fs.classList.toggle('is-collapsed'); label(); });
      var help = $('[data-nnp-size-help]');
      if (help && fs === optionSets[optionSets.length - 1]) help.parentNode.insertBefore(btn, help); else fs.appendChild(btn);
    });

    function numOf(s) { var m = String(s).match(/\d+(?:[.,]\d+)?/); return m ? parseFloat(m[0].replace(',', '.')) : null; }
    optionSets.forEach(function (fs, i) {
      fs.addEventListener('change', function () {
        var opts = selectedOptions();
        var next = resolve(opts, i);
        if (next && !next.available && fs.querySelector('.nnp-pills--color')) {
          var cands = variants.filter(function (x) { return x.available && x.options[i] === opts[i]; });
          if (cands.length) {
            var dist = function (x) {
              var d = 0;
              x.options.forEach(function (o, j) {
                if (j === i) return;
                var a = numOf(o), b = numOf(next.options[j]);
                d += (a !== null && b !== null) ? Math.abs(a - b) : (o === next.options[j] ? 0 : 1000);
              });
              return d;
            };
            cands.sort(function (a, b) { return dist(a) - dist(b); });
            toast(next.title + ' ist gerade ausverkauft – ' + cands[0].title + ' gewählt');
            next = cands[0];
          }
        }
        setVariant(next, { user: true });
      });
    });

    /* ---------- Menge & Mengenrabatt ---------- */
    var qtyInput = $('[data-nnp-qty]');
    function setQty(n, silent) {
      n = Math.max(1, Math.min(parseInt(n, 10) || 1, maxQty(state.variant)));
      state.qty = n;
      if (qtyInput) qtyInput.value = n;
      if (!silent) recalc();
    }
    if (qtyInput) {
      $('[data-nnp-qty-minus]').addEventListener('click', function () { setQty(state.qty - 1); });
      $('[data-nnp-qty-plus]').addEventListener('click', function () { setQty(state.qty + 1); });
      qtyInput.addEventListener('input', function () { if (qtyInput.value !== '') setQty(qtyInput.value); });
      qtyInput.addEventListener('blur', function () { setQty(qtyInput.value); });
    }
    $$('[data-nnp-tier]').forEach(function (b) {
      b.addEventListener('click', function () {
        var target = parseInt(b.getAttribute('data-qty'), 10) || 1;
        var q = target <= 1 ? 1 : Math.max(1, target - state.cartQty);
        setQty(q);
        if (target > 1 && state.cartQty > 0) toast('Menge ' + q + ' + ' + state.cartQty + ' im Warenkorb = ' + (q + state.cartQty) + ' Stück');
        if (qtyInput) bump(qtyInput);
      });
    });

    function currentTier(eff) {
      var t = null;
      tiers.forEach(function (x) { if (eff >= x.qty) t = x; });
      return t;
    }
    function recalc() {
      var v = state.variant;
      if (!v) return;
      var q = state.qty;
      var eff = q + state.cartQty;
      var t = currentTier(eff);
      var pct = t ? t.pct : 0;
      var full = v.price * q;
      var line = pctPrice(full, pct);
      var save = full - line;

      var totalEl = $('[data-nnp-total]');
      tween(totalEl, state.shownTotal, line);
      state.shownTotal = line;
      var saveEl = $('[data-nnp-save]');
      if (saveEl) {
        saveEl.hidden = save <= 0;
        if (save > 0) saveEl.textContent = 'du sparst ' + money(save) + ' (−' + pct + ' %)';
      }

      if (tiers.length) {
        var next = null;
        for (var i = 0; i < tiers.length; i++) { if (tiers[i].qty > eff) { next = tiers[i]; break; } }
        $$('[data-nnp-tier]').forEach(function (b) {
          var bq = parseInt(b.getAttribute('data-qty'), 10);
          var active = t ? bq === t.qty : bq <= 1;
          b.classList.toggle('is-active', active);
          b.classList.toggle('is-next', !!next && bq === next.qty);
        });
        var fill = $('[data-nnp-tier-fill]');
        if (fill) fill.style.width = Math.max(3, Math.min(eff / tiers[tiers.length - 1].qty, 1) * 100) + '%';
        var nudge = $('[data-nnp-nudge]');
        if (nudge) {
          var html = '';
          if (t) html += '<strong>−' + t.pct + ' % aktiv.</strong> ';
          if (next) {
            var need = next.qty - eff;
            html += 'Noch ' + need + ' Stück bis −' + next.pct + ' % (' + money(pctPrice(v.price, next.pct)) + ' pro Stück).';
          } else if (t) {
            html += 'Bester Stückpreis.';
          }
          nudge.innerHTML = html;
        }
        var cartNote = $('[data-nnp-cart-note]');
        if (cartNote) {
          cartNote.hidden = state.cartQty <= 0;
          if (state.cartQty > 0) cartNote.textContent = 'Deine ' + state.cartQty + ' Stück dieses Artikels im Warenkorb zählen mit.';
        }
      }

      var sp = $('[data-nnp-sticky-price]');
      if (sp) sp.textContent = q > 1 ? q + ' Stk. · ' + money(line) : money(line);

      renderShipping($('[data-nnp-ship]'), $('[data-nnp-ship-text]'), $('[data-nnp-ship-fill]'), state.cartTotal + line, true);
      renderShipTip(state.cartTotal + line);
    }

    /* Versand + Mengenrabatt zusammen zeigen: „Mit 8 Stück versandkostenfrei + 5 % Rabatt" (nur wenn in ≤ 10 Stück erreichbar) */
    var shipTip = $('[data-nnp-ship-tip]');
    function renderShipTip(amount) {
      if (!shipTip) return;
      var v = state.variant, target = 0, tier = null;
      if (v && v.available && D.freeShipping && amount < D.freeShipping) {
        for (var n = state.qty + 1; n <= state.qty + 10 && n <= maxQty(v); n++) {
          var t = currentTier(n + state.cartQty);
          if (state.cartTotal + pctPrice(v.price * n, t ? t.pct : 0) >= D.freeShipping) { target = n; tier = t; break; }
        }
      }
      shipTip.hidden = !target;
      if (!target) return;
      shipTip.setAttribute('data-qty', target);
      shipTip.innerHTML = 'Mit <strong>' + target + ' Stück</strong> versandkostenfrei' + (tier ? ' + <strong>−' + tier.pct + ' %</strong> Mengenrabatt' : '') + ' <span aria-hidden="true">›</span>';
    }
    if (shipTip) shipTip.addEventListener('click', function () {
      var q = parseInt(shipTip.getAttribute('data-qty'), 10);
      if (!q) return;
      setQty(q);
      if (qtyInput) bump(qtyInput);
      toast('Menge auf ' + q + ' Stück gesetzt');
    });

    /* ---------- Versand & Lieferung ---------- */
    function renderShipping(box, textEl, fillEl, amount, withIcon) {
      if (!box || !D.freeShipping) return;
      var rest = D.freeShipping - amount;
      var icon = withIcon && textEl.querySelector('svg') ? textEl.querySelector('svg').outerHTML : '';
      box.classList.toggle('is-free', rest <= 0);
      var from = D.shipFrom ? 'Versand ab ' + D.shipFrom + ' – ' : '';
      textEl.innerHTML = icon + '<span>' + (rest <= 0
        ? 'Versandkostenfrei ' + D.shipNote + ' ✓'
        : from + 'noch <strong>' + money(rest) + '</strong> bis versandkostenfrei ' + D.shipNote) + '</span>';
      if (fillEl) fillEl.style.width = Math.max(4, Math.min(amount / D.freeShipping, 1) * 100) + '%';
    }
    function addWorkdays(date, n) {
      var d = new Date(date.getTime()), added = 0;
      while (added < n) { d.setDate(d.getDate() + 1); var wd = d.getDay(); if (wd !== 0 && wd !== 6) added++; }
      return d;
    }
    function parseCutoff() {
      var m = String(D.delivery && D.delivery.cutoff || '').match(/^(\d{1,2})[:.](\d{2})$/);
      return m ? { h: +m[1], m: +m[2] } : null;
    }
    function renderDelivery(stateName) {
      var el = $('[data-nnp-delivery]');
      var cutEl = $('[data-nnp-cutoff]');
      var ok = stateName === 'in' || stateName === 'low';
      var now = new Date();
      var cut = parseCutoff();
      var workday = now.getDay() !== 0 && now.getDay() !== 6;
      var minsLeft = cut ? (cut.h * 60 + cut.m) - (now.getHours() * 60 + now.getMinutes()) : -1;
      /* Versandtag: heute vor Cut-off (Mo–Fr), sonst nächster Werktag. Ohne Cut-off zählt ab heute. */
      var shipDay = (cut && !(workday && minsLeft > 0)) ? addWorkdays(now, 1) : now;
      var f = { weekday: 'short', day: '2-digit', month: '2-digit' };
      if (el) {
        el.hidden = !ok || !D.delivery.show;
        if (ok && D.delivery.show) {
          var a = addWorkdays(shipDay, D.delivery.min).toLocaleDateString('de-DE', f);
          var b = addWorkdays(shipDay, Math.max(D.delivery.max, D.delivery.min)).toLocaleDateString('de-DE', f);
          el.querySelector('[data-nnp-delivery-date]').textContent = a === b ? a : a + ' – ' + b;
        }
      }
      if (cutEl) {
        /* Nur vor dem Cut-off zeigen – danach reicht das Lieferdatum */
        cutEl.hidden = !(ok && cut && workday && minsLeft > 0);
        if (!cutEl.hidden) {
          var h = Math.floor(minsLeft / 60), m = minsLeft % 60;
          var left = (h ? h + ' Std.' : '') + (h && m ? ' ' : '') + (m ? m + ' Min.' : '');
          cutEl.querySelector('[data-nnp-cutoff-text]').textContent = 'Innerhalb von ' + left + ' bestellen – Versand noch heute';
        }
      }
    }
    if (parseCutoff()) setInterval(function () { renderDelivery(stockInfo(state.variant).state); }, 60000);

    /* ---------- Warenkorb ---------- */
    function fetchCart() {
      return fetch(D.root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          state.cartTotal = cart.total_price || 0;
          state.cartCount = cart.item_count || 0;
          state.cartQty = (cart.items || []).reduce(function (s, it) { return it.product_id === D.productId ? s + it.quantity : s; }, 0);
          return cart;
        });
    }
    function updateHeader(cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('shide', cart.item_count === 0);
      });
      document.querySelectorAll('.cart_total_price').forEach(function (el) { el.textContent = money(cart.total_price); });
      document.dispatchEvent(new CustomEvent('nnp:cart-updated', { detail: { cart: cart } }));
    }
    function addItems(items) {
      return fetch(D.root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    }

    var errBox = $('[data-nnp-error]');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!D.sheet && D.cartType !== 'drawer') return; /* Standard: Warenkorbseite */
        e.preventDefault();
        var atc = $('[data-nnp-atc]');
        if (!atc || atc.disabled || atc.classList.contains('is-loading')) return;
        if (errBox) errBox.hidden = true;
        atc.classList.add('is-loading');
        var v = state.variant, q = state.qty;
        var eff = q + state.cartQty;
        var t = currentTier(eff);
        fetch(D.root + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function (item) {
            atc.classList.remove('is-loading');
            atc.classList.add('is-added');
            setTimeout(function () { atc.classList.remove('is-added'); }, 1800);
            return fetchCart().then(function (cart) {
              updateHeader(cart);
              recalc();
              if (D.sheet) openSheet(item, v, q, t, cart);
              else if (window.theme && theme.Cart && theme.Cart.prototype._onProductAdded) theme.Cart.prototype._onProductAdded();
            });
          })
          .catch(function (err) {
            atc.classList.remove('is-loading');
            if (errBox) {
              errBox.textContent = (err && (err.description || err.message)) || 'Der Artikel konnte nicht in den Warenkorb gelegt werden.';
              errBox.hidden = false;
            }
          });
      });
    }

    /* ---------- „Im Warenkorb"-Dialog ---------- */
    var sheet = $('[data-nnp-sheet]');
    function openSheet(item, v, q, t, cart) {
      if (!sheet || typeof sheet.showModal !== 'function') { window.location.href = D.root + 'cart'; return; }
      var pct = t ? t.pct : 0;
      var line = pctPrice(v.price * q, pct);
      var img = item && item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : D.image;
      var lineEl = $('[data-nnp-sheet-line]');
      lineEl.innerHTML = '';
      if (img) { var im = document.createElement('img'); im.src = img; im.alt = ''; im.width = 56; im.height = 56; lineEl.appendChild(im); }
      var txt = document.createElement('div');
      txt.className = 'nnp-sheet__line-txt';
      var strong = document.createElement('strong');
      strong.textContent = D.title;
      txt.appendChild(strong);
      txt.appendChild(document.createTextNode((D.hasOnlyDefault ? '' : v.title + ' · ') + q + ' Stk.'));
      lineEl.appendChild(txt);
      var pr = document.createElement('span');
      pr.className = 'nnp-sheet__line-price';
      pr.textContent = money(line);
      lineEl.appendChild(pr);

      var saveEl = $('[data-nnp-sheet-save]');
      saveEl.hidden = !pct;
      if (pct) saveEl.textContent = '✓ Mengenrabatt −' + pct + ' % – wird im Warenkorb automatisch abgezogen';
      var shipBox = $('[data-nnp-sheet-ship]');
      if (shipBox && D.freeShipping) {
        shipBox.hidden = false;
        renderShipping(shipBox, $('[data-nnp-sheet-ship-text]'), $('[data-nnp-sheet-ship-fill]'), cart.total_price, false);
      }
      $('[data-nnp-sheet-count]').textContent = cart.item_count;
      buildSheetXs();
      sheet.showModal();
      document.body.classList.remove('nnp-sticky-on');
    }
    function buildSheetXs() {
      var box = $('[data-nnp-sheet-xs]');
      if (!box) return;
      var items = xsItems.filter(function (li) { return !li.hidden && !li.classList.contains('is-added'); }).slice(0, 2);
      box.innerHTML = '';
      box.hidden = !items.length;
      if (!items.length) return;
      var h = document.createElement('p');
      h.className = 'nnp-block__title';
      h.textContent = 'Passt dazu';
      box.appendChild(h);
      items.forEach(function (li) {
        var sel = li.querySelector('[data-nnp-xs-variant]');
        var row = document.createElement('div');
        row.className = 'nnp-sheet__xs-item';
        var srcImg = li.querySelector('.nnp-xs__img img');
        if (srcImg) { var im = srcImg.cloneNode(); im.removeAttribute('loading'); row.appendChild(im); }
        var name = document.createElement('span');
        var opt = sel.tagName === 'SELECT' ? sel.options[sel.selectedIndex] : null;
        name.textContent = li.querySelector('.nnp-xs__title').textContent.trim() + (opt ? ' · ' + (opt.getAttribute('data-title') || opt.textContent) : '') + (xsQty(li) > 1 ? ' · ' + xsQty(li) + ' Stk.' : '');
        row.appendChild(name);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'nnp-sheet__xs-add';
        btn.textContent = '+ ' + li.querySelector('[data-nnp-xs-price]').textContent;
        btn.addEventListener('click', function () {
          xsAdd(li, btn).then(function (cart) {
            btn.classList.add('is-done');
            btn.textContent = '✓ Hinzugefügt';
            var lb = li.querySelector('[data-nnp-xs-add]');
            lb.disabled = true;
            lb.querySelector('[data-nnp-xs-add-label]').textContent = 'Im Warenkorb';
            $('[data-nnp-sheet-count]').textContent = cart.item_count;
            renderShipping($('[data-nnp-sheet-ship]'), $('[data-nnp-sheet-ship-text]'), $('[data-nnp-sheet-ship-fill]'), cart.total_price, false);
          }).catch(function () {});
        });
        row.appendChild(btn);
        box.appendChild(row);
      });
    }
    if (sheet) {
      $$('[data-nnp-sheet-close]').forEach(function (b) { b.addEventListener('click', function () { sheet.close(); }); });
      sheet.addEventListener('click', function (e) { if (e.target === sheet) sheet.close(); });
    }

    /* ---------- Zubehör ---------- */
    /* Größe sichtbar und – wenn das Datenblatt Innen-/Außen-Ø liefert – passend zum gewählten Schlauch vorgewählt:
       Schellen: Spannbereich enthält den Außen-Ø (2 Stück, je Ende eine) · Rohre/Verbinder: Außen-Ø = Innen-Ø des Schlauchs */
    var xs = $('[data-nnp-xs]');
    var xsItems = xs ? $$('[data-nnp-xs-item]', xs) : [];
    var xsLimit = xs ? (parseInt(xs.getAttribute('data-limit'), 10) || 3) : 0;
    var xsSubEl = xs ? $('[data-nnp-xs-sub]', xs) : null;
    var xsSubDefault = xsSubEl ? xsSubEl.textContent : '';
    function xsSel(li) { return li.querySelector('[data-nnp-xs-variant]'); }
    function xsQty(li) { return parseInt(li.querySelector('[data-nnp-xs-qty]').value, 10) || 1; }
    function xsUnit(li) {
      var sel = xsSel(li);
      var o = sel.tagName === 'SELECT' ? sel.options[sel.selectedIndex] : sel;
      return parseInt(o.getAttribute('data-price'), 10) || 0;
    }
    function fmtMm(n) { return String(n).replace('.', ','); }
    function xsRender(li) {
      var unit = xsUnit(li), q = xsQty(li);
      li.querySelector('[data-nnp-xs-price]').textContent = money(unit * q);
      var each = li.querySelector('[data-nnp-xs-each]');
      each.hidden = q < 2;
      if (q > 1) each.textContent = q + ' × ' + money(unit);
      var hint = li.querySelector('[data-nnp-xs-hint]');
      var fit = li.__fit && li.__fit.ids.indexOf(xsSel(li).value) !== -1;
      hint.hidden = !fit;
      if (fit) hint.textContent = '✓ ' + li.__fit.text;
    }
    function rangeOf(t) {
      var m = String(t).replace(/,/g, '.').match(/(\d+(?:\.\d+)?)\s*[-–]\s*(\d+(?:\.\d+)?)/);
      return m ? [parseFloat(m[1]), parseFloat(m[2])] : null;
    }
    function hoseDims() {
      var v = state.variant;
      if (!v) return null;
      for (var i = 0; i < dtRows.length; i++) {
        var m = dtRows[i].__nnp;
        var on = m.variants ? m.variants.indexOf(v) !== -1 : v.options[m.option] === m.value;
        if (on && dtRows[i].__dims) return dtRows[i].__dims;
      }
      return null;
    }
    function xsMatch() {
      if (!xs) return;
      var dims = hoseDims();
      var shown = 0, fitted = false;
      xsItems.forEach(function (li) {
        var sel = xsSel(li);
        var kind = /spann/i.test(li.dataset.option) ? 'clamp' : (/au(ß|ss)en/i.test(li.dataset.option) ? 'pipe' : null);
        var need = dims && kind ? (kind === 'clamp' ? dims.ad : dims.id) : null;
        var show = true;
        li.__fit = null;
        var defQty = li.getAttribute('data-qty') || '1';
        if (!li.__userQty) li.querySelector('[data-nnp-xs-qty]').value = defQty;
        if (need && sel.tagName === 'SELECT') {
          var best = null, bestScore = -1, ids = [];
          Array.prototype.forEach.call(sel.options, function (o) {
            var t = o.getAttribute('data-title') || o.textContent, score = -1;
            if (kind === 'clamp') {
              var r = rangeOf(t);
              if (r && need >= r[0] && need <= r[1]) score = Math.min(need - r[0], r[1] - need); /* möglichst mittig im Spannbereich */
            } else {
              var n = parseNum(t);
              if (n !== null && Math.abs(n - need) <= 0.5) score = 0;
            }
            if (score >= 0) { ids.push(o.value); if (score > bestScore) { bestScore = score; best = o; } }
          });
          if (best) {
            if (!li.__userPick || ids.indexOf(sel.value) === -1) { sel.value = best.value; li.__userPick = false; }
            li.__fit = { ids: ids, text: 'Passt zu Ø ' + fmtMm(dims.id) + ' mm' + (defQty === '2' ? ' · 2 Stück für beide Enden' : '') };
            fitted = true;
          } else {
            show = false;
          }
        }
        if (show && shown >= xsLimit) show = false;
        li.hidden = !show;
        if (show) shown++;
        xsRender(li);
      });
      xs.hidden = shown === 0;
      if (xsSubEl) xsSubEl.textContent = fitted ? 'Größe passend zu Ø ' + fmtMm(dims.id) + ' mm vorgewählt – bei Bedarf änderbar.' : xsSubDefault;
    }
    function xsAdd(li, btn) {
      btn.disabled = true;
      return addItems([{ id: parseInt(xsSel(li).value, 10), quantity: xsQty(li) }])
        .then(function () {
          li.classList.add('is-added');
          if (btn.hasAttribute('data-nnp-xs-add')) btn.querySelector('[data-nnp-xs-add-label]').textContent = 'Im Warenkorb';
          toast('✓ ' + li.querySelector('.nnp-xs__title').textContent.trim() + ' im Warenkorb');
          return fetchCart().then(function (cart) { updateHeader(cart); recalc(); return cart; });
        })
        .catch(function (err) { btn.disabled = false; toast((err && err.description) || 'Konnte nicht hinzugefügt werden'); throw err; });
    }
    if (xs) {
      xs.addEventListener('change', function (e) {
        var li = e.target.closest('[data-nnp-xs-item]');
        if (!li) return;
        if (e.target.hasAttribute('data-nnp-xs-variant')) li.__userPick = true;
        if (e.target.hasAttribute('data-nnp-xs-qty')) li.__userQty = true;
        /* nach Änderung wieder hinzufügbar */
        var btn = li.querySelector('[data-nnp-xs-add]');
        if (li.classList.contains('is-added')) { li.classList.remove('is-added'); btn.disabled = false; btn.querySelector('[data-nnp-xs-add-label]').textContent = 'Hinzufügen'; }
        xsRender(li);
      });
      xsItems.forEach(function (li) {
        var btn = li.querySelector('[data-nnp-xs-add]');
        btn.addEventListener('click', function () { xsAdd(li, btn).catch(function () {}); });
      });
    }

    /* ---------- Galerie ---------- */
    var track = $('[data-nnp-track]');
    var slides = track ? $$('.nnp-gallery__slide', track) : [];
    var thumbs = $$('.nnp-thumb');
    var countEl = $('[data-nnp-count]');
    var current = 0;
    function goTo(i, instant) {
      if (!track || !slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * i, behavior: instant || reduceMotion ? 'auto' : 'smooth' });
      setActive(i);
    }
    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, j) {
        t.classList.toggle('is-active', j === i);
        if (j === i) { t.setAttribute('aria-selected', 'true'); } else { t.removeAttribute('aria-selected'); }
      });
      if (countEl) countEl.textContent = i + 1;
      var at = thumbs[i];
      if (at && at.parentNode.scrollWidth > at.parentNode.clientWidth) {
        at.parentNode.scrollTo({ left: at.offsetLeft - at.parentNode.clientWidth / 2 + at.clientWidth / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
    function goToMedia(mediaId) {
      for (var i = 0; i < slides.length; i++) { if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) { goTo(i); return; } }
    }
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          if (i !== current) setActive(i);
        });
      }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-index'), 10)); }); });
      var pBtn = $('[data-nnp-prev]'), nBtn = $('[data-nnp-next]');
      if (pBtn) pBtn.addEventListener('click', function () { goTo(current - 1); });
      if (nBtn) nBtn.addEventListener('click', function () { goTo(current + 1); });
      current = parseInt($('[data-nnp-gallery]').getAttribute('data-start'), 10) || 0;
      window.addEventListener('resize', function () { goTo(current, true); });
    }

    /* Lightbox */
    var lb = $('[data-nnp-lightbox]');
    var zooms = $$('[data-nnp-zoom]');
    var lbIndex = 0;
    function lbShow(i) {
      lbIndex = (i + zooms.length) % zooms.length;
      var img = $('[data-nnp-lb-img]');
      img.src = zooms[lbIndex].getAttribute('data-nnp-zoom');
      var src = zooms[lbIndex].querySelector('img');
      img.alt = src ? src.alt : '';
    }
    if (lb && zooms.length && typeof lb.showModal === 'function') {
      zooms.forEach(function (z, i) { z.addEventListener('click', function () { lbShow(i); lb.showModal(); }); });
      $('[data-nnp-lb-close]').addEventListener('click', function () { lb.close(); });
      $('[data-nnp-lb-prev]').addEventListener('click', function () { lbShow(lbIndex - 1); });
      $('[data-nnp-lb-next]').addEventListener('click', function () { lbShow(lbIndex + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
        if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
      });
      if (zooms.length < 2) { $('[data-nnp-lb-prev]').hidden = true; $('[data-nnp-lb-next]').hidden = true; }
    }

    /* ---------- Kaufbereich: scrollt mit, bleibt am Ende stehen (Desktop) ---------- */
    var infoCol = $('[data-nnp-info]');
    if (infoCol) {
      var placeInfo = function () {
        if (window.innerWidth < 990) { infoCol.style.top = ''; return; }
        infoCol.style.top = Math.min(24, window.innerHeight - infoCol.offsetHeight - 24) + 'px';
      };
      placeInfo();
      window.addEventListener('resize', placeInfo);
      if ('ResizeObserver' in window) new ResizeObserver(placeInfo).observe(infoCol);
    }

    /* ---------- Sticky-Leiste ---------- */
    var sticky = $('[data-nnp-sticky]');
    var mainAtc = $('[data-nnp-atc]');
    if (sticky && mainAtc) {
      /* Scroll statt IntersectionObserver: greift auch bei Sprüngen (Anker-Links), bei denen der Button nie sichtbar war */
      var stickyOn = false, ticking = false;
      var checkSticky = function () {
        ticking = false;
        var show = mainAtc.getBoundingClientRect().bottom < 0;
        if (show === stickyOn) return;
        stickyOn = show;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $('[data-nnp-sticky-atc]').tabIndex = show ? 0 : -1;
        document.body.classList.toggle('nnp-sticky-on', show);
      };
      /* Höhe der Leiste für Chat-/Hochscroll-Button (CSS: --nnp-sticky-h) */
      var setStickyH = function () { document.documentElement.style.setProperty('--nnp-sticky-h', sticky.offsetHeight + 'px'); };
      setStickyH();
      if ('ResizeObserver' in window) new ResizeObserver(setStickyH).observe(sticky);
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(checkSticky); }
      }, { passive: true });
      checkSticky();
      $('[data-nnp-sticky-atc]').addEventListener('click', function () {
        if (!form) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit(mainAtc); else mainAtc.click();
      });
    }

    /* ---------- Beschreibung: Navigation, Akkordeons, interaktives Datenblatt ---------- */
    var desc = $('[data-nnp-desc]');
    var accs = desc ? $$('details', desc) : [];
    function openAcc(d) {
      if (!d) return;
      d.open = true;
      scrollToEl(d);
    }
    function findReviews() {
      return document.querySelector('[id$="__reviews"]') || document.querySelector('[id*="appio"], .appio-reviews, [class*="appio-"]');
    }
    function findFaq() { return document.querySelector('.nv-faq'); }

    var nav = $('[data-nnp-detail-nav]');
    if (nav) {
      var addChip = function (label, fn) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = label;
        b.addEventListener('click', fn);
        nav.appendChild(b);
      };
      accs.forEach(function (d) {
        var s = d.querySelector('summary');
        var label = s ? s.textContent.replace(/[▼▲]/g, '').trim() : '';
        if (label) addChip(label, function () { openAcc(d); });
      });
      if (findReviews()) addChip('Bewertungen', function () { scrollToEl(findReviews()); });
      if (findFaq()) addChip('FAQ', function () { scrollToEl(findFaq()); });
      if (!nav.children.length) nav.hidden = true;
    }

    if (D.accordionAnim && !reduceMotion) {
      accs.forEach(function (d) {
        var sum = d.querySelector('summary');
        var body = sum && sum.nextElementSibling;
        if (!sum || !body || !body.animate) return;
        sum.addEventListener('click', function (e) {
          e.preventDefault();
          if (d.__anim) return;
          if (d.open) {
            d.__anim = body.animate([{ height: body.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 240, easing: 'ease-in' });
            d.__anim.onfinish = function () { d.open = false; d.__anim = null; };
          } else {
            d.open = true;
            d.__anim = body.animate([{ height: '0px', opacity: 0 }, { height: body.offsetHeight + 'px', opacity: 1 }], { duration: 320, easing: 'cubic-bezier(.2,.7,.2,1)' });
            d.__anim.onfinish = function () { d.__anim = null; };
          }
        });
      });
    }

    var dtRows = [];
    function parseNum(s) {
      var m = String(s).replace(/\s/g, '').match(/-?\d+(?:[.,]\d+)?/);
      return m ? parseFloat(m[0].replace(',', '.')) : null;
    }
    function matchRow(cells) {
      var hits = variants.filter(function (v) {
        if (!v.sku) return false;
        var sk = v.sku.toLowerCase();
        return cells.some(function (c) { return c.toLowerCase() === sk; });
      });
      if (hits.length) return { variants: hits };
      var num = parseNum(cells[0]);
      if (num === null || !variants.length) return null;
      for (var oi = 0; oi < variants[0].options.length; oi++) {
        var seen = {};
        for (var k = 0; k < variants.length; k++) {
          var val = variants[k].options[oi];
          if (seen[val]) continue;
          seen[val] = true;
          var nums = String(val).match(/\d+(?:[.,]\d+)?/g);
          if (nums && nums.length === 1 && parseFloat(nums[0].replace(',', '.')) === num) return { option: oi, value: val };
        }
      }
      return null;
    }
    function rowVariant(m) {
      var cur = state.variant;
      if (m.variants) {
        var best = m.variants[0], bs = -1;
        m.variants.forEach(function (v) {
          var s = v.available ? 10 : 0;
          v.options.forEach(function (o, i) { if (cur && cur.options[i] === o) s++; });
          if (s > bs) { bs = s; best = v; }
        });
        return best;
      }
      var opts = cur ? cur.options.slice() : variants[0].options.slice();
      opts[m.option] = m.value;
      return resolve(opts, m.option);
    }
    function highlightDatasheet() {
      var v = state.variant;
      dtRows.forEach(function (tr) {
        var m = tr.__nnp;
        var on = m.variants ? m.variants.indexOf(v) !== -1 : (v && v.options[m.option] === m.value);
        tr.classList.toggle('is-current', !!on);
      });
    }
    if (desc && D.datasheet && !D.hasOnlyDefault) {
      $$('table', desc).forEach(function (table) {
        var rows = [];
        /* Spalten Innen-/Außen-Ø für die Zubehör-Vorauswahl */
        var idI = -1, adI = -1;
        $$('tr', table).some(function (tr) {
          var hc = $$('th, td', tr).map(function (c) { return c.textContent.trim(); });
          if (!hc.some(function (c) { return /au(ß|ss)en/i.test(c); })) return false;
          hc.forEach(function (c, i) {
            if (idI < 0 && /innen/i.test(c)) idI = i;
            if (adI < 0 && /au(ß|ss)en/i.test(c)) adI = i;
          });
          return true;
        });
        $$('tbody tr', table).forEach(function (tr) {
          var cells = $$('td', tr).map(function (td) { return td.textContent.trim(); });
          if (!cells.length) return;
          var m = matchRow(cells);
          if (m) {
            tr.__nnp = m;
            var all = $$('th, td', tr).map(function (c) { return c.textContent.trim(); });
            if (idI > -1 && adI > -1) tr.__dims = { id: parseNum(all[idI]), ad: parseNum(all[adI]) };
            rows.push(tr);
          }
        });
        if (rows.length < 2) return;
        rows.forEach(function (tr) {
          tr.classList.add('nnp-dt-row');
          tr.tabIndex = 0;
          tr.title = 'Diese Größe wählen';
          var pick = function () {
            var v = rowVariant(tr.__nnp);
            if (!v) return;
            setVariant(v, { user: true });
            toast((v.available ? '✓ Gewählt: ' : 'Ausverkauft: ') + v.title);
            var opt = $('[data-nnp-options]');
            scrollToEl(opt, 'center');
            if (opt && !reduceMotion) { opt.classList.remove('is-flash'); void opt.offsetWidth; opt.classList.add('is-flash'); }
          };
          tr.addEventListener('click', pick);
          tr.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
        });
        dtRows = dtRows.concat(rows);
        var wrap = table.closest('.nn-table-wrap') || table;
        var hint = document.createElement('p');
        hint.className = 'nnp-dt-hint';
        hint.innerHTML = '<svg class="nnp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 11V5.5a1.5 1.5 0 0 1 3 0V10m0-1.5a1.5 1.5 0 0 1 3 0V11m0-1a1.5 1.5 0 0 1 3 0v4.5A6.5 6.5 0 0 1 11.5 21h-.8a6 6 0 0 1-4.6-2.2L3.4 15.5a1.5 1.5 0 0 1 2.3-1.9L9 17V11"/></svg><span>Tipp: Zeile antippen – die Größe wird direkt oben ausgewählt.</span>';
        wrap.parentNode.insertBefore(hint, wrap);
      });
      if (dtRows.length) {
        $$('[data-nnp-to-datasheet]').forEach(function (b) {
          b.hidden = false;
          b.addEventListener('click', function () {
            var d = dtRows[0].closest('details');
            if (d) openAcc(d); else scrollToEl(dtRows[0]);
          });
        });
        var help = $('[data-nnp-size-help]');
        if (help) {
          help.hidden = false;
          help.addEventListener('click', function () {
            var d = dtRows[0].closest('details');
            if (d) openAcc(d); else scrollToEl(dtRows[0]);
          });
        }
      }
    }

    /* ---------- Kundenstimme (echte Appio-Bewertung) ---------- */
    var quote = $('[data-nnp-quote]');
    if (quote && D.reviews) {
      var list = D.reviews;
      try { if (typeof list === 'string') list = JSON.parse(list); } catch (e) { list = null; }
      if (Array.isArray(list)) {
        var pickR = null;
        /* Nur klar positive Stimmen: 4–5 Sterne, kurz genug, ohne typische Einschränkungs-Wörter */
        var negative = /\b(leider|aber|nicht|kein|keine|schade|problem|mangel|defekt|falsch|trotzdem|jedoch)\b/i;
        var lang = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
        var countries = { de: ['DE', 'AT', 'CH', 'LU', 'LI'], en: ['GB', 'UK', 'US', 'IE'], fr: ['FR', 'BE', 'CH', 'LU'] }[lang];
        list.forEach(function (r) {
          if (countries && r.country && countries.indexOf(String(r.country).toUpperCase()) === -1) return;
          var body = String(r.body || '').trim();
          if (!body || body.length < 12 || body.length > 200 || (r.rating || 0) < 4 || negative.test(body)) return;
          if (!pickR || r.rating > pickR.rating || (r.rating === pickR.rating && body.length > String(pickR.body).length)) pickR = r;
        });
        if (pickR) {
          var qTitle = String(pickR.title || '').trim();
          $('[data-nnp-quote-text]', quote).textContent = (qTitle && !negative.test(qTitle) && String(pickR.body).trim() !== qTitle ? qTitle + ' – ' : '') + String(pickR.body).trim();
          var parts = String(pickR.customer || 'Kunde').trim().split(/\s+/);
          var name = parts[0] + (parts.length > 1 ? ' ' + parts[parts.length - 1].charAt(0) + '.' : '');
          $('[data-nnp-quote-author]', quote).textContent = name + ' · Kundenbewertung';
          $('[data-nnp-quote-stars]', quote).style.setProperty('--nnp-rating', (pickR.rating / 5 * 100) + '%');
          quote.hidden = false;
        }
      }
    }

    /* ---------- Scroll-Links ---------- */
    $$('[data-nnp-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = a.getAttribute('data-nnp-scroll') === 'reviews' ? findReviews() : document.getElementById('nnp-details-' + root.getAttribute('data-section-id'));
        if (!target) return;
        e.preventDefault();
        scrollToEl(target);
      });
    });

    /* ---------- Einblenden beim Scrollen ---------- */
    var reveals = $$('.nnp-r');
    if (root.classList.contains('nnp--anim') && !reduceMotion && 'IntersectionObserver' in window && !(window.Shopify && Shopify.designMode)) {
      var ro = new IntersectionObserver(function (entries) {
        var n = 0;
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.style.transitionDelay = (n++ * 70) + 'ms';
          en.target.classList.add('is-in');
          ro.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { ro.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    }

    /* ---------- Start ---------- */
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var startId = idInput ? parseInt(idInput.value, 10) : null;
    var startV = variants.filter(function (v) { return v.id === startId; })[0] || variants[0];
    setVariant(startV);
    fetchCart().then(recalc).catch(function () {});
  }

  function boot() { document.querySelectorAll('[data-nnp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-nnp]'); if (r) init(r); });
})();
